import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthSecurity } from "@/hooks/useAuthSecurity";

interface UseAuthOptions {
  redirectTo?: string | null;
}

export function useAuth(optionsOrRedirectTo: UseAuthOptions | string = {}) {
  const navigate = useNavigate();
  const { user, loading, sessionRestored } = useAuthSecurity();
  const hasRedirected = useRef(false);
  const redirectTo =
    typeof optionsOrRedirectTo === "string"
      ? optionsOrRedirectTo
      : optionsOrRedirectTo.redirectTo === undefined
      ? "/"
      : optionsOrRedirectTo.redirectTo;

  useEffect(() => {
    if (loading || !sessionRestored || !redirectTo) return;

    if (!user && !hasRedirected.current) {
      hasRedirected.current = true;
      navigate(redirectTo, { replace: true });
    }
  }, [loading, navigate, redirectTo, sessionRestored, user]);

  return { user, loading, sessionRestored };
}
